/* eslint-disable no-console */
import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service';

export const getCareLabelLibrary = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_COMMON}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadCareLibrary = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL.IMPORT_LIBRARY}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteSingleCareLibrary = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_COMMON}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteMultipleCareLibrary = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_COMMON}/1`, {
      data: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addCareLibraryService = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_COMMON}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editCareLibraryService = async (payload, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_COMMON}/${id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCareLabelGroup = async (searchText) => {
  try {
    if (searchText === '') return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_GROUP}`);
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_GROUP}`, { params: { searchText } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCareGroupService = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_GROUP}`, {
      data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCareLabelGroupId = async (id, payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_GROUP}/${id}`, {
      params: { ...payload },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllCareLabelLibrary = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_COMMON}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCareLabelGroupUserId = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_GROUP}`, {
      params: { loggedInUserId: id },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editCareLabelGroup = async (id, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_GROUP}/${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveCareLabelGroupService = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL.CARE_LABEL_GROUP}`, {
      ...payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportExcelService = async (data) => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        withCredentials: true, // Moved here
      };

      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.USERINSTRUCTIONS.DOWNLOAD_CARE_LABEL}`, data, config) // Empty body, config as 3rd argument
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const uploadFile = async (data) => {
  const loginFormData = new FormData();
  loginFormData.append('xls', data.xls);
  loginFormData.append('careType', data.careType);
  try {
    return await apiClient.post(`${apiEndpoint}${API.CARE_LABEL.UPLOAD_FILE}`, loginFormData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchUserInstruction = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USERINSTRUCTIONS.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addUserInstruction = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.USERINSTRUCTIONS.GET}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const UpdateUserInstruction = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.USERINSTRUCTIONS.GET}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteMultipleUserInstruction = async (payload) => {
  try {
    const ids = payload.ids.join(',');
    return await apiClient.delete(`${apiEndpoint}${API.USERINSTRUCTIONS.GET}?ids=${ids}`);
  } catch (error) {
    console.error('Error deleting multiple user instructions:', error);
    throw error;
  }
};

export const fetchUserColumnDetail = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_USER_DETAILS_DATA}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addUpdateColumnsDetailService = async (payload, _id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_USER_DETAILS_DATA}/${_id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUserTabs = async (id, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_TABS}/${id}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const importCareUserExcelSheet = async (data) => {
  const loginFormData = new FormData();
  loginFormData.append('xls', data.xls);
  loginFormData.append('tabId', data.tabId);
  loginFormData.append('checked', data.checked);
  try {
    return await apiClient.post(`${apiEndpoint}${API.USERINSTRUCTIONS.UPLOAD_FILE}`, loginFormData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const deleteColumnService = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_USER_DETAILS_DATA}/${id}`);
  } catch (error) {
    console.error('Error deleting multiple user instructions:', error);
    throw error;
  }
};

export const updateSequenceUserInstruction = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_USER_DETAILS_DATA}/${payload.id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addUpdateUserInstructionDetail = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_TABS}/${payload.id}`, { rowDetails: payload.rowDetails });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteUserInstructionDetail = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_TABS}/${data.id}?rowId=${data?.rowId}`);
  } catch (error) {
    console.error('Error deleting multiple user instructions:', error);
    throw error;
  }
};

export const getUserInstructionCareGroup = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_CARE_USER_GROUP}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteMultipleGroupService = async (ids) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_CARE_USER_GROUP}?ids=${ids}`);
  } catch (err) {
    console.error('Service: careUserInstructions.service.js, Method: deleteCareUserInstructionGroup : Error:', err);
    throw err;
  }
};

export const deactivateRowInGroupService = async (groupId, rowId) => {
  try {
    return await apiClient.patch(
      `${apiEndpoint}${API.USERINSTRUCTIONS.GET_CARE_USER_GROUP}/${groupId}/tab-detail/${rowId}/deactivate`
    );
  } catch (err) {
    console.error("Service: care-label.service.js, Method: deactivateRowInGroupService : Error:", err);
    throw err;
  }
};

export const getGroupUserInstructionsDetails = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_CARE_USER_GROUP}/${params?.id}`, { ...params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveCareUserGroupService = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_CARE_USER_GROUP}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const checkUniqueProductType = async (isRequired = false) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USERINSTRUCTIONS.CHECK_UNIQUE_PRODUCT_TYPE}?isRequired=${isRequired}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCareLibraries = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_CARE_LIBRARIES}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllColumns = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USERINSTRUCTIONS.GET_ALL_COLUMNS}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const refreshTabs = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USERINSTRUCTIONS.REFRESH_TABS}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
